const __request = require(`./__request/__request_contentType_json`);

// 机票预定
// 接口文档地址：http://183.58.24.99:9999/swagger-ui.html?tdsourcetag=s_pcqq_aiomsg#/
const reserve = (pParameter) => {
  // if (!pParameter) pParameter = {};
  // const data = {...pParameter}

  let data = {
    method: 'post',
    // urlSuffix: '/flight/domestic/buyer/white/order/reserve',
    urlSuffix:'/buyer/dom/white/submit',
    data: pParameter,
    enable_error_alert: false // 临时隐藏
  }
  console.log(data)
  return __request(data)
}
module.exports = reserve;
